import Hero from "./components/Hero/Hero";
import Dashboard from "./components/Dashboard/Dashboard";
import FeaturesGrid from "./components/FeaturesGrid/FeaturesGrid";
import Industries from "./components/Industries/Industries";
import Testimonials from "./components/Testimonials/Testimonials";
import ResearchShowcase from "./components/ResearchShowcase/ResearchShowcase";
import OnboardingPipeline from "./components/OnboardingPipeline/OnboardingPipeline";
import PricingCTA from "./components/PricingCTA/PricingCTA";
import AskAIPanel from "./components/AskAIPanel/AskAIPanel";
import MultilingualBento from "./components/MultilingualBento/MultilingualBento";
import VisitorPersona from "./components/VisitorPersona/VisitorPersona";
import Navigation from "../Home/components/Navigation";
import PricingCards from "../Home/components/PricingCards";
import ComprehensiveFAQ from "../Home/components/ComprehensiveFAQ";
import PublicLandingChatbot from "../../adapters/publicSite/PublicLandingChatbot";
import LanderFooter from "./components/LanderFooter/LanderFooter";
import "./LanderRoot.css";

export default function LanderPage() {
    return (
        <>
            <Navigation />
            <div className="lander-root">
                <Hero />
                <Dashboard />
                <Testimonials />
                <OnboardingPipeline />
                <FeaturesGrid />
                <MultilingualBento />
                <VisitorPersona />
                <PricingCards compactTopSpacing />
                <PricingCTA />
                <Industries />
                <ResearchShowcase />
                <div className="lander-faq-tight">
                    <ComprehensiveFAQ />
                </div>
            </div>
            <AskAIPanel />
            <LanderFooter />
            <PublicLandingChatbot />
        </>
    );
}
